import React, { useEffect, useRef, useState } from "react";
import { Table, Input, Select, Button, Tabs, Modal, DatePicker, Radio, message, Form } from "antd";
import styled from "styled-components";
import COLORS from "common/Colors";
import { useHistory } from "react-router-dom";
import { CSVLink } from "react-csv";
import { CALL_API, CALL_FEATCH_API } from "common/API";
import { useSelector } from "react-redux";
import { getUserInfo, getUserList, getCountryList } from "redux/selectors";
import { PRACTICE_AREAS } from "common/Constants";
import dayjs from "dayjs";
import { ReactComponent as Editicon } from "../../assets/Edit_Pencil_01.svg";
import { ReactComponent as TrashDelete } from "../../assets/Trash_Full.svg";
import { ReactComponent as CloneIcon } from "../../assets/Clone.svg";
import { ReactComponent as FilterIcon } from "../../assets/filter-svgrepo-com (2).svg";
import { DropdownCheckBox } from "atoms/UIDropdown/Dropdown";
import { EditOutlined } from "@mui/icons-material";

const { Option } = Select;

const API = {
    GET_MATTER: "insyts-matter/getmatter",
    GET_MATTER_FILTER: "insyts-matter/getmatterfilter",
    GET_FILTER_LIST: "insyts-matter/getmatterfilterlist",
    GET_APPLY_FILTER: "insyts-matter/getapplyfilter",
    APPLY_FILTER: "insyts-matter/applyfilter",
    DELETE_MATTER: "insyts-matter/deletematter",
    GET_ALL_MATTER: "insyts-matter/getallmatterlist",
    CLONE_MATTER: "insyts-matter/clonematter",
    ADD_MATTER: "insyts-matter/addmatter"
};

const MatterWrap = styled.div`
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;
    flex-wrap: wrap;
    gap: 10px;
    .btn-matter{
        color: #fff!important;
    }
  }
  .title {
    font-size: 18px;
    font-weight: 600;
    color: ${COLORS.TEXT.PRIMARY};
  }
  .ant-table { border-radius: 8px; }
  .status-active   { font-weight: 500; }
  .status-inactive { color: #6b7280; font-weight: 500; }

  .action-icons {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 25px;
    opacity: 0;
    transition: opacity 0.2s ease;
  }
  .ant-table-tbody > tr:hover .action-icons {
    opacity: 1;
  }

  .filters-header {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 10px;
  }
  .total-count {
    font-weight: 600;
    font-size: 16px;
    color: ${COLORS.TEXT.PRIMARY};
  }
  .filters {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 10px;
    flex-wrap: nowrap;
  }
  .filter-input { min-width: 180px; max-width: 220px; }

  /* FIX 4 (search): Rounded search input styling */
  .search-input-wrap {
    .ant-input-affix-wrapper {
      border-radius: 20px !important;
      height: 38px !important;
      border: 1px solid #d9d9d9;
      min-width: 200px;
    }
    .ant-input-affix-wrapper:hover,
    .ant-input-affix-wrapper:focus-within {
      border-color: ${COLORS.PRIMARY} !important;
      box-shadow: none !important;
    }
  }

  .filter-input.ant-input-affix-wrapper {
    border-radius: 20px !important;
    height: 38px !important;
    display: flex;
    align-items: center;
    padding: 0 11px;
    border: 1px solid #d9d9d9;
  }
  .filter-input.ant-input-affix-wrapper .ant-input {
    border: none !important;
    box-shadow: none !important;
  }
  .filter-input.ant-input-affix-wrapper:hover,
  .filter-input.ant-input-affix-wrapper:focus-within {
    border-color: ${COLORS.PRIMARY} !important;
    box-shadow: none !important;
  }
  .filter-input .ant-input-prefix { margin-right: 6px; }
  .filter-input .ant-select-selector {
    border-radius: 20px !important;
    height: 38px !important;
    display: flex;
    align-items: center;
  }
`;

const StyledModal = styled(Modal)`
  .ant-modal-content { border-radius: 12px; }
`;
const MatterNameCell = styled.div`
  font-size: 13px;
  font-weight: 500;
  color: #111827;
  line-height: 1.5;
`;
const MatterIdCell = styled.div`
  font-size: 11.5px;
  color: #9ca3af;
  margin-top: 1px;
`;
const DraftBadge = styled.span`
  display: inline-block;
  background: #374151;
  color: #fff;
  font-size: 11.5px;
  font-weight: 500;
  padding: 2px 10px;
  border-radius: 4px;
`;

const FilterBtn = styled.div`
  position: relative;
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #deefee;
  border-radius: 20px;
  background: #deefee;
  cursor: pointer;
  color: #6b7280;
  flex-shrink: 0;
  transition: border-color 0.2s;
`;
const FilterBadge = styled.div`
  position: absolute;
  top: -5px;
  right: -5px;
  background: #ef4444;
  color: #fff;
  font-size: 9px;
  font-weight: 700;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1.5px solid #fff;
`;
const CloneInput = styled(Input)`
  && {
    height: 42px;
    border-radius: 6px;
    border: 1px solid #d1d5db;
    font-size: 14px;
    color: #111827;
    margin-top: 8px;
    &:hover, &:focus { border-color: #9ca3af; box-shadow: none; }
  }
`;
const ModalFooterRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 32px;
`;
const CancelBtn = styled(Button)`
  && {
    height: 38px;
    padding: 0 24px;
    border-radius: 10px;
    border: 1px solid #000000;
    color: #000000;
    font-weight: 500;
    box-shadow: none;
    &:hover { border-color: #000000; color: #111827; }
  }
`;
const CloneBtn = styled(Button)`
  && {
    height: 38px;
    padding: 0 28px;
    border-radius: 10px;
    background: #00685F;
    border: none;
    color: #ffffff !important;
    font-weight: 600;
    box-shadow: none;
    &:hover, &:focus { background: #005a4d !important; color: #ffffff !important; }
  }
`;
const FilterModalWrap = styled.div`
  padding: 8px 0 0;
`;
const FilterRow = styled.div`
  display: flex;
  gap: 24px;
  margin-bottom: 28px;
  flex-wrap: wrap;
  border-radius: 20px;
`;
const FilterField = styled.div`
  flex: 1;
  min-width: 180px;
`;
const FilterLabel = styled.div`
  font-size: 13px;
  font-weight: 500;
  color: #374151;
  margin-bottom: 8px;
`;
const FullSelect = styled(Select)`
  && { width: 100%; }
  && .ant-select-selector {
    border-radius: 20px !important;
    min-height: 40px !important;
    height: auto !important;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    border: 1px solid #d1d5db !important;
    box-shadow: none !important;
    padding: 4px 8px !important;
  }
  && .ant-select-selection-overflow {
    flex-wrap: wrap;
    gap: 4px;
  }
  && .ant-select-selection-item {
    border-radius: 12px;
    background: #e6f7f2;
    border: 1px solid #b2f0e3;
    font-size: 12px;
    height: 24px;
    line-height: 22px;
  }
  &&.ant-select-focused .ant-select-selector {
    border-color: #9ca3af !important;
    box-shadow: none !important;
  }
`;
const DateRangeRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
const RadioGroup = styled(Radio.Group)`
  && { display: flex; gap: 20px; margin-top: 4px; }
  && .ant-radio-wrapper { font-size: 13px; color: #374151; }
  && .ant-radio-checked .ant-radio-inner { border-color: #10b981; background: #10b981; }
`;
const FilterModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding-top: 16px;
  border-top: 1px solid #f3f4f6;
  margin-top: 8px;
`;
const ClearAllBtn = styled(Button)`
  && {
    height: 38px;
    padding: 0 24px;
    border-radius: 6px;
    border: 1px solid #000000;
    color: #000000;
    font-weight: 500;
    box-shadow: none;
    &:hover { border-color: #000000; color: #111827; }
  }
`;
const ApplyBtn = styled(Button)`
  && {
    height: 38px;
    padding: 0 28px;
    border-radius: 6px;
    background: #00685F;
    border: none;
    color: #ffffff !important;
    font-weight: 600;
    box-shadow: none;
    &:hover, &:focus { background: #005a4d !important; color: #ffffff !important; }
  }
`;
const StyledTable = styled(Table)`
  padding-top: 10px;
  table {
    width: 100% !important;
    border: 1px solid #ccc;
  }
  .ant-table-content {
    overflow-x: auto;
    white-space: nowrap;
    color: ${COLORS.TEXT.PRIMARY};
    font-size: 14px;
  }
  .ant-table-row:nth-child(even) {
    background-color: #fafafa;
  }
  .normal-column {
    min-width: 300px;
    white-space: normal;
  }
  .ant-table-thead .ant-table-cell {
    font-weight: bold;
    color: ${COLORS.TEXT.PRIMARY};
    white-space: nowrap;
    padding: 12px 16px !important;
    height: 48px !important;
  }
  .ant-table-tbody .ant-table-cell {
    padding: 12px 16px !important;
    height: 48px !important;
  }
  .non-white {
    background: #f9f9f9;
  }
  .ant-select-selector {
    min-width: 150px;
  }
`;
const StyledTabs = styled(Tabs)`
  .ant-tabs-nav {
    border-radius: 5px;
    font-weight: 500;
    color: ${COLORS.TEXT.PRIMARY};
  }
  .ant-tabs-tab {
    font-size: 16px;
    &:hover { color: ${COLORS.TEXT.PRIMARY}; }
  }
  .ant-tabs-ink-bar {
    background: ${COLORS.TAB};
    font-weight: bold;
  }
  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: ${COLORS.TAB};
    font-weight: 500;
    font-size: 16px;
  }
`;
const { RangePicker } = DatePicker;
const FullRangePicker = styled(RangePicker)`
  && {
    width: 100%;
    height: 40px;
    border-radius: 20px;
    border: 1px solid #d1d5db;
    box-shadow: none;
    padding: 0 12px;
    &:hover, &.ant-picker-focused {
      border-color: #9ca3af;
      box-shadow: none;
    }
  }
`;

const DEFAULT_ADV = {
    referrer: [],
    practiceArea: [],
    planDateFrom: null,
    planDateTo: null,
    createdBy: [],
    createdDateFrom: null,
    createdDateTo: null,
    clientRefNumber: undefined,
    legalFilingDeadline: undefined,
    legalFilingDeadlineMet: undefined,
};

const normaliseMatter = (item) => ({
    key: item.matterId || item.matter_id || String(item.id),
    matter: item.jobTitle || item.information?.jobTitle || "",
    matterId: item.matterId || item.matter_id || "",
    client: item.clientName || item.client?.clientName || "",
    leadAttorney: item.leadAttorney || item.stakeHolder?.leadAttorney || "",
    referringAttorney: item.referringAttorney || item.stakeHolder?.referringAttorney || "",
    matterStatus: item.matterStatus || "Not Started",
    pfaStatus: item.pfaStatus || item.financial_resourcePlan?.pfaStatus || "---",
    createdBy: item.createdBy || "",
    createdDate:
        item.createdAt ||
        item["createdAt "] ||
        item.createdDate ||
        "",
    tab: ["Completed", "completed"].includes(item.matterStatus) ? "completed" : "open",
    originalData: { ...item },
});

const formatCreatedDate = (dateStr) => {
    if (!dateStr) return "";
    const d = dayjs(dateStr);
    if (!d.isValid()) return "";
    const day = d.date();
    const suffix =
        day % 10 === 1 && day !== 11 ? "st" :
            day % 10 === 2 && day !== 12 ? "nd" :
                day % 10 === 3 && day !== 13 ? "rd" : "th";
    return `${day}${suffix} ${d.format("MMM YYYY")}`;
};

const Matter = () => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [allData, setAllData] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const PAGE_LIMIT = 10;
    const [activeTab, setActiveTab] = useState("open");

    const [filters, setFilters] = useState({ search: "", status: "", client: "", lead: "", matterName: "", });
    const [form] = Form.useForm();
    const [filterOptions, setFilterOptions] = useState({
        statuses: [],
        clients: [],
        leads: [],
        referrers: [],
        practiceAreas: [],
        createdBys: [],
        matterNames: [],
    });

    const [cloneModal, setCloneModal] = useState(false);
    const [cloneRecord, setCloneRecord] = useState(null);
    const [cloneName, setCloneName] = useState("");
    const [cloneLoading, setCloneLoading] = useState(false);
    const [cloneNameError, setCloneNameError] = useState("");
    const [deleteModal, setDeleteModal] = useState(false);
    const [deleteRecord, setDeleteRecord] = useState(null);

    const [clientList, setClientList] = useState([]);

    const [filterModal, setFilterModal] = useState(false);
    const [advFilters, setAdvFilters] = useState(DEFAULT_ADV);
    const [tempAdv, setTempAdv] = useState(DEFAULT_ADV);

    // Guards the very first run of the advFilters effect so we don't
    // double-fetch on mount (a separate effect already calls fetchMatters(1) once).
    const isFirstAdvRun = useRef(true);

    const isAdvFilterActive = Object.entries(advFilters).some(([, v]) =>
        Array.isArray(v) ? v.length > 0 : v !== undefined && v !== null
    );

    const history = useHistory();
    const csvLinkRef = useRef();

    const userInfo = useSelector(getUserInfo);
    const countryList = useSelector(getCountryList);
    const managingOffice = userInfo?.managingOffice || countryList[0]?.countryname;
    const userId = userInfo?.userid || userInfo?.email || "ajay@gmail.com";
    const userList = useSelector(getUserList);

    const getUserName = (emailOrId) => {
        if (!emailOrId) return "--";
        const user = (userList || []).find(
            (u) => u.userid === emailOrId || u.email === emailOrId
        );
        return user?.fullname || emailOrId;
    };

    const csvData = data.map((item) => ({
        "Matter Name": item.matter,
        "Matter ID": item.matterId,
        "Client": item.client,
        "Lead Attorney": item.leadAttorney,
        "Referring Attorney": item.referringAttorney,
        "Matter Status": item.matterStatus,
        "PFA Status": item.pfaStatus,
        "Created By": item.createdBy,
        "Created Date": item.createdDate,
    }));

    useEffect(() => {
        fetchFilterList();
        fetchClients();
    }, []);

    const fetchClients = async () => {
        try {
            const res = await CALL_FEATCH_API("insyts-legal/getalllegalclients", "GET");
            const data = res?.response?.data || res?.data || [];
            setClientList(data);
        } catch (err) { console.error("Client fetch error:", err); }
    };

    const fetchFilterList = async () => {
        try {
            const resp = await CALL_FEATCH_API(
                `${API.GET_FILTER_LIST}?managingoffice=${managingOffice}&userid=${userId}`,
                "GET"
            );
            if (resp) {
                const allItems = resp?.response?.data || resp?.data || [];

                setFilterOptions({
                    statuses: [...new Set(allItems.map((d) => d.matterStatus).filter(Boolean))],
                    clients: [...new Set(allItems.map((d) => d.clientName).filter(Boolean))],
                    leads: [...new Set(allItems.map((d) => d.leadAttorney).filter(Boolean))],
                    referrers: [...new Set(allItems.map((d) => d.referringAttorney).filter(Boolean))],
                    practiceAreas: [...new Set(allItems.map((d) => d.practiceArea).filter(Boolean))],
                    createdBys: [...new Set(allItems.map((d) => d.createdBy).filter(Boolean))],
                    matterNames: [...new Set(allItems.map((d) => d.matterName).filter(Boolean))],
                });
            }
        } catch (err) {
            console.error("fetchFilterList error:", err);
        }
    };

    const fetchMatters = async (page = 1, overrideFilters = null, tabOverride = null) => {
        setLoading(true);
        try {
            const activeFilters = overrideFilters || filters;
            const currentTab = tabOverride || activeTab;
            const { search, status, client, lead, matterName } = activeFilters;

            const statusArr = Array.isArray(status) ? status : status ? [status] : [];
            const clientArr = Array.isArray(client) ? client : client ? [client] : [];
            const leadArr = Array.isArray(lead) ? lead : lead ? [lead] : [];
            const matterArr = Array.isArray(matterName) ? matterName : matterName ? [matterName] : [];

            const hasBasicFilter = search || statusArr.length || clientArr.length || leadArr.length || matterArr.length;

            if (!hasBasicFilter) {
                const params = new URLSearchParams({
                    managingoffice: managingOffice,
                    userid: userId,
                    page: String(page),
                    limit: String(PAGE_LIMIT),
                });
                const resp = await CALL_FEATCH_API(`${API.GET_MATTER}?${params.toString()}`, "GET");
                if (resp) {
                    const rawList = resp?.response?.data || resp?.data || resp?.matters || [];
                    const total = resp?.response?.pagination?.total || resp?.total || rawList?.length;
                    const list = Array.isArray(rawList)
                        ? rawList.map(normaliseMatter).filter((m) => m.tab === currentTab)
                        : [];
                    setAllData(list);
                    setData(list);
                    setTotalCount(total);
                    setCurrentPage(page);
                }
                return;
            }

            const baseParams = { managingoffice: managingOffice, userid: userId };

            let callParams = [];
            if (search) {
                callParams = [{ ...baseParams, search }];
            } else {
                const statuses = statusArr.length ? statusArr : [null];
                const clients = clientArr.length ? clientArr : [null];
                const leads = leadArr.length ? leadArr : [null];
                const matters = matterArr.length ? matterArr : [null];
                for (const s of statuses) {
                    for (const c of clients) {
                        for (const l of leads) {
                            for (const m of matters) {
                                const p = { ...baseParams };
                                if (s) p.status = s;
                                if (c) p.client = c;
                                if (l) p.lead = l;
                                if (m) p.matter = m;
                                callParams.push(p);
                            }
                        }
                    }
                }
            }

            const fetchSinglePage = async (paramObj) => {
                const urlParams = new URLSearchParams({
                    ...paramObj,
                    page: String(page),
                    limit: String(PAGE_LIMIT)
                });
                const resp = await CALL_FEATCH_API(`${API.GET_MATTER_FILTER}?${urlParams.toString()}`, "GET");
                const rawList = resp?.response?.data || resp?.data || resp?.matters || [];
                const total = resp?.response?.pagination?.total || resp?.total || rawList?.length;
                return { items: Array.isArray(rawList) ? rawList : [], total };
            };

            const results = await Promise.all(callParams.map(fetchSinglePage));

            const merged = Object.values(
                results.flatMap(r => r.items).reduce((acc, item) => {
                    const id = item.matterId || item.matter_id || String(item.id);
                    if (id && !acc[id]) acc[id] = item;
                    return acc;
                }, {})
            );

            const total = results[0]?.total || merged.length;
            const list = merged.map(normaliseMatter).filter((m) => m.tab === activeTab);
            setAllData(list);
            setData(list);
            setTotalCount(total);
            setCurrentPage(page);

        } catch (err) {
            console.error("fetchMatters error:", err);
            message.error("Failed to fetch matters.");
        } finally {
            setLoading(false);
        }
    };

    const fetchApplyFilter = async (page = 1) => {
        setLoading(true);
        try {
            const toArr = (v) => (Array.isArray(v) ? v : v ? [v] : []);

            const referrerArr = toArr(advFilters.referrer);
            const practiceArr = toArr(advFilters.practiceArea);
            const createdByArr = toArr(advFilters.createdBy);

            const payload = {
                managingoffice: managingOffice,
                userid: userId,
                ...(referrerArr.length && { referringAttorney: referrerArr }),
                ...(practiceArr.length && { practiceArea: practiceArr }),
                ...(advFilters.planDateFrom && { planStartDateFrom: advFilters.planDateFrom.format("YYYY-MM-DD") }),
                ...(advFilters.planDateTo && { planStartDateTo: advFilters.planDateTo.format("YYYY-MM-DD") }),
                ...(createdByArr.length && { createdBy: createdByArr }),
                ...(advFilters.createdDateFrom && { createdDateFrom: advFilters.createdDateFrom.format("YYYY-MM-DD") }),
                ...(advFilters.createdDateTo && { createdDateTo: advFilters.createdDateTo.format("YYYY-MM-DD") }),
                ...(advFilters.clientRefNumber && { clientReferenceNumber: advFilters.clientRefNumber === "yes" ? "Yes" : "No" }),
                ...(advFilters.legalFilingDeadline && { legalFilingDeadline: advFilters.legalFilingDeadline === "yes" ? "Yes" : "No" }),
                ...(advFilters.legalFilingDeadlineMet && { deadlineMet: advFilters.legalFilingDeadlineMet === "yes" ? "Yes" : "No" }),
            };

            const resp = await CALL_API(API.APPLY_FILTER, "POST", payload);
            if (resp) {
                const rawList = resp.response || resp.data || resp.matters || resp || [];
                const list = Array.isArray(rawList)
                    ? rawList.map(normaliseMatter).filter((m) => m.tab === activeTab)
                    : [];
                setData(list.slice(0, PAGE_LIMIT));
                setTotalCount(list.length);
                setCurrentPage(1);
            }
        } catch (err) {
            console.error("fetchApplyFilter error:", err);
            message.error("Failed to apply filters.");
        } finally {
            setLoading(false);
        }
    };

    const applyFormFilters = () => {
        const allValues = form.getFieldsValue();
        const newFilters = {
            ...filters,
            status: allValues.status || [],
            client: allValues.client || [],
            lead: allValues.lead || [],
            matterName: Array.isArray(allValues.matterName)
                ? allValues.matterName
                : allValues.matterName ? [allValues.matterName] : [],
        };
        setFilters(newFilters);
        fetchMatters(1, newFilters);
    };

    const deleteMatter = async (matterId) => {
        try {
            await CALL_API(API.DELETE_MATTER, "DELETE", { matterId });
            message.success("Matter deleted successfully.");
            if (isAdvFilterActive) {
                fetchApplyFilter(currentPage);
            } else {
                fetchMatters(currentPage);
            }
        } catch (err) {
            console.error("deleteMatter error:", err);
            message.error("Failed to delete matter.");
        }
    };

    useEffect(() => {
        fetchFilterList();
        fetchMatters(1);
    }, []);

    // FIX: previously this effect only fired fetchApplyFilter when a filter was
    // active, so clearing all advanced filters (Clear All, or Apply with empty
    // fields) left the table showing stale filtered data forever. Now it falls
    // back to fetchMatters(1) whenever advFilters becomes inactive again.
    useEffect(() => {
        if (isFirstAdvRun.current) {
            isFirstAdvRun.current = false;
            return;
        }
        if (isAdvFilterActive) {
            fetchApplyFilter(1);
        } else {
            fetchMatters(1);
        }
    }, [advFilters]);

    const handleTabChange = (tab) => {
        setActiveTab(tab);
        setCurrentPage(1);

        if (tab === "completed") {
            const newFilters = { ...filters, status: ["Closed"] };
            setFilters(newFilters);
            fetchMatters(1, newFilters, "completed");
        } else {
            const newFilters = { ...filters, status: [] };
            setFilters(newFilters);
            fetchMatters(1, newFilters, "open");
        }
    };

    const handleEdit = async (e, record) => {
        e.stopPropagation();
        try {
            setLoading(true);
            const resp = await CALL_FEATCH_API(
                `insyts-matter/viewmatter?matterid=${record.matterId}`,
                "GET"
            );
            const fullData = resp?.response?.data || resp?.response || resp?.data || resp;

            history.push({
                pathname: `/create-matter/${record.key}`,
                state: {
                    editData: {
                        ...fullData,
                        responsiblePersonnel: fullData?.responsiblePersonnel || [],
                    },
                    editMode: true,
                    from: history.location.pathname,
                },
            });
        } catch (err) {
            console.error("Edit fetch error:", err);
            message.error("Failed to fetch matter details.");
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = (e, record) => {
        e.stopPropagation();
        setDeleteRecord(record);
        setDeleteModal(true);
    };

    const handleDeleteConfirm = async () => {
        await deleteMatter(deleteRecord.matterId);
        setDeleteModal(false);
        setDeleteRecord(null);
    };

    const handleDeleteCancel = () => {
        setDeleteModal(false);
        setDeleteRecord(null);
    };

    const handleCloneClick = async (e, record) => {
        e.stopPropagation();
        try {
            setLoading(true);
            const resp = await CALL_FEATCH_API(
                `insyts-matter/viewmatter?matterid=${record.matterId}`,
                "GET"
            );
            const fullData = resp?.data || resp?.response?.data || resp?.response || resp;
            setCloneRecord({ originalData: fullData });
            setCloneName(`Clone - ${record.matter}`);
            setCloneModal(true);
        } catch (err) {
            console.error("Clone fetch error:", err);
            message.error("Failed to fetch full matter details.");
        } finally {
            setLoading(false);
        }
    };

    const handleCloneConfirm = async () => {
        if (!cloneName.trim()) {
            setCloneNameError("Please enter a name.");
            return;
        }
        if (cloneNameError) {
            return;
        }
        setCloneLoading(true);
        try {
            const original = cloneRecord?.originalData;

            const payload = {
                clientId: original?.clientId || "",
                client: {
                    clientId: original?.clientId || "",
                    clientName: original?.clientName || "",
                    clientReferenceNumber: original?.clientReferenceNumber || "",
                    managingOffice: userInfo?.managingoffice[0] || "",
                },
                proposalId: original?.proposalId || "",
                information: {
                    jobTitle: cloneName.trim(),
                    location: original?.location || "",
                    objective: original?.objective || "",
                    practiceArea: original?.practiceArea || "",
                },
                stakeHolder: {
                    leadAttorney: original?.leadAttorney || "",
                    referringAttorney: original?.referringAttorney || "",
                    planStartDate: original?.planStartDate || "",
                    planEndDate: original?.planEndDate || "",
                    legalFilingDeadline: original?.legalFilingDeadline || "",
                    deadlineMet: original?.deadlineMet || false,
                },
                matterStatus: "Draft",
                financial_resourcePlan: {
                    billingEntity: original?.financial_resourcePlan?.billingEntity || "",
                    billingEntityId: original?.financial_resourcePlan?.billingEntityId || "",
                    tax: original?.financial_resourcePlan?.tax || "",
                    financialYear: original?.financial_resourcePlan?.financialYear || "2025",
                    mandays: original?.financial_resourcePlan?.mandays || 0,
                    currency: original?.financial_resourcePlan?.currency || "US Dollar",
                    localCurrencyAmount: original?.financial_resourcePlan?.localCurrencyAmount || 0,
                    conversionRate: original?.financial_resourcePlan?.conversionRate || 1,
                    usdAmount: original?.financial_resourcePlan?.usdAmount || 0,
                    billingAmount: original?.financial_resourcePlan?.billingAmount || 0,
                    pfaStatus: original?.financial_resourcePlan?.pfaStatus || "Not Applicable",
                },
                resourceList: original?.resourceList || [],
                subcontractList: original?.subcontractList || [],
                billingPreference: {
                    billingMethod: original?.billingMethod || "",
                    billingPreferenceEmployee: original?.billingPreferenceEmployee || [],
                    billingHourlyRate: original?.billingHourlyRate || null,
                    billingContingencyFee: original?.billingContingencyFee || "",
                    billingFlatFee: original?.billingFlatFee || "",
                },
                responsiblePersonnel: original?.responsiblePersonnel || [],
                createdBy: userId,
                clonedstatus: true
            };
            await CALL_API(API.ADD_MATTER, "POST", payload);
            message.success("Matter cloned successfully!");
            setCloneModal(false);
            setCloneRecord(null);
            setCloneName("");
            if (isAdvFilterActive) fetchApplyFilter(currentPage);
            else fetchMatters(currentPage);
        } catch (err) {
            console.error("Clone error:", err);
            message.error("Clone failed.");
        } finally {
            setCloneLoading(false);
        }
    };

    const handleCloneCancel = () => {
        setCloneModal(false);
        setCloneRecord(null);
        setCloneName("");
        setCloneNameError("");
    };

    const openFilterModal = () => {
        setTempAdv({ ...advFilters });
        setFilterModal(true);
    };

    const closeFilterModal = () => setFilterModal(false);

    const handleAdvChange = (key, value) =>
        setTempAdv((p) => ({ ...p, [key]: value }));

    const handleApplyFilter = () => {
        setAdvFilters({ ...tempAdv });
        setFilterModal(false);
    };

    // FIX: Clear All previously only reset the modal's draft state (tempAdv),
    // so the actually-applied advFilters (and thus the table) never changed
    // unless the user then also clicked Apply Filter. Now it clears both the
    // draft and the applied filters and closes the modal, matching Apply's UX.
    const handleClearAll = () => {
        setTempAdv(DEFAULT_ADV);
        setAdvFilters(DEFAULT_ADV);
        setFilterModal(false);
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
        if (isAdvFilterActive) {
            fetchApplyFilter(page);
        } else {
            fetchMatters(page);
        }
    };

    const advFilterCount = Object.values(advFilters).filter((v) =>
        Array.isArray(v) ? v.length > 0 : v !== undefined && v !== null
    ).length;

    const columns = [
        {
            title: "Matter", key: "matter",
            render: (_, record) => (
                <div>
                    <MatterNameCell>{record.matter}</MatterNameCell>
                    <MatterIdCell>{record.matterId}</MatterIdCell>
                </div>
            ),
        },
        { title: "Client", dataIndex: "client" },
        {
            title: "Lead Attorney",
            dataIndex: "leadAttorney",
            render: (val) => getUserName(val),
        },
        {
            title: "Referring Attorney",
            dataIndex: "referringAttorney",
            render: (val) => getUserName(val),
        },
        {
            title: "Matter Status", dataIndex: "matterStatus",
            render: (status) =>
                status === "Draft"
                    ? <DraftBadge>Draft</DraftBadge>
                    : <span className={status === "Active" ? "status-active" : "status-inactive"}>{status}</span>,
        },
        {
            title: "PFA Status", dataIndex: "pfaStatus",
            render: (status) => (
                <span className={status === "Approved" ? "status-active" : "status-inactive"}>{status}</span>
            ),
        },
        {
            title: "Created By",
            render: (_, record) => (
                <div>
                    <div style={{ fontSize: 13, color: "#111827" }}>
                        {getUserName(record.createdBy)}
                    </div>
                    {/* FIX 6: date is already formatted DD-MMM-YYYY order */}
                    <small style={{ fontSize: 12, color: "#6b7280", fontStyle: "italic" }}>
                        {formatCreatedDate(record.createdDate)}
                    </small>
                </div>
            ),
        },
        {
            title: "Action",
            key: "action",
            width: 120,
            align: "center",
            render: (_, record) => {
                const currentUser = userInfo?.userid || userInfo?.email;
                const isLeadAttorney = record.leadAttorney === currentUser;
                const isReferringAttorney = record.referringAttorney === currentUser;
                const isCreator = record.createdBy === currentUser;
                const status = record.matterStatus;
                const canEdit =
                    (isLeadAttorney || isReferringAttorney || isCreator) &&
                    status !== "Closed";
                const isDraft = record.matterStatus === "Draft";
                return (
                    <div className="action-icons">
                        {/* Draft → only Edit + Delete */}
                        {isDraft ? (
                            <>
                                {canEdit && (
                                    <EditOutlined
                                        style={{
                                            display: "inline-flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            width: "28px",
                                            height: "28px",
                                            borderRadius: "6px",
                                            cursor: "pointer",
                                            fontSize: "14px",
                                            background: "#deefee",
                                            color: "#00685F",
                                            transition: "opacity 0.15s"
                                        }}
                                        onClick={(e) => handleEdit(e, record)}
                                    />
                                )}

                                <TrashDelete
                                    onClick={(e) => handleDelete(e, record)}
                                    style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        width: "28px",
                                        height: "28px",
                                        borderRadius: "6px",
                                        cursor: "pointer",
                                        fontSize: "14px",
                                        background: "#deefee",
                                        color: "#00685F",
                                        transition: "opacity 0.15s"
                                    }}
                                />
                            </>
                        ) : (
                            <>
                                {/* Non-Draft → Clone */}
                                <CloneIcon
                                    onClick={(e) => handleCloneClick(e, record)}
                                    style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        width: "28px",
                                        height: "28px",
                                        borderRadius: "6px",
                                        cursor: "pointer",
                                        fontSize: "14px",
                                        background: "#deefee",
                                        color: "#00685F",
                                        transition: "opacity 0.15s"
                                    }}
                                />

                                {/* Edit */}
                                {canEdit && (
                                    <EditOutlined
                                        onClick={(e) => handleEdit(e, record)}
                                        style={{
                                            display: "inline-flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            width: "28px",
                                            height: "28px",
                                            borderRadius: "6px",
                                            cursor: "pointer",
                                            fontSize: "14px",
                                            background: "#deefee",
                                            color: "#00685F",
                                            transition: "opacity 0.15s"
                                        }}
                                    />
                                )}

                                {/* Delete only for Not Started */}
                                {record.matterStatus === "Not Started" && (
                                    <TrashDelete
                                        onClick={(e) => handleDelete(e, record)}
                                        style={{
                                            display: "inline-flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            width: "28px",
                                            height: "28px",
                                            borderRadius: "6px",
                                            cursor: "pointer",
                                            fontSize: "14px",
                                            background: "#deefee",
                                            color: "#00685F",
                                            transition: "opacity 0.15s"
                                        }}
                                    />
                                )}
                            </>
                        )}
                    </div>
                );
            }
        },
    ];

    const tabItems = [
        { key: "open", label: "Open" },
        { key: "completed", label: "Completed" },
    ];

    const ensureArray = (val) => (Array.isArray(val) ? val : []);

    const statusOptions = ensureArray(filterOptions?.statuses)?.length
        ? ensureArray(filterOptions.statuses)
        : [...new Set(allData.map((d) => d.matterStatus))];

    const clientOptions = ensureArray(filterOptions?.clients)?.length
        ? ensureArray(filterOptions.clients)
        : [...new Set(allData.map((d) => d.client))];

    const leadOptions = ensureArray(filterOptions?.leads)?.length
        ? ensureArray(filterOptions.leads)
        : [...new Set(allData.map((d) => d.leadAttorney))];

    const referrerOptions = ensureArray(filterOptions?.referrers)?.length
        ? ensureArray(filterOptions.referrers)
        : [...new Set(allData.map((d) => d.referringAttorney))];

    const createdByOpts = ensureArray(filterOptions?.createdBys)?.length
        ? ensureArray(filterOptions.createdBys)
        : [...new Set(allData.map((d) => d.createdBy))];

    const matterNameOptions = ensureArray(filterOptions?.matterNames)?.length
        ? ensureArray(filterOptions.matterNames)
        : [...new Set(allData.map((d) => d.matter))];

    return (
        <MatterWrap>
            {/* ── Header ── */}
            <div className="header">
                <div className="title">Matter</div>
                <div className="d-flex gap-4 mb-3">
                    <CSVLink data={csvData} filename="matters.csv" ref={csvLinkRef} style={{ display: "none" }} />
                    <Button
                        // type="primary"
                        className="btn-matter"
                        style={{ background: COLORS.PRIMARY, borderRadius: "6px" }}
                        onClick={() => history.push("/create-matter")}
                    >
                        Create Matter
                    </Button>
                </div>
            </div>

            {/* ── Tabs ── */}
            <StyledTabs activeKey={activeTab} onChange={handleTabChange} items={tabItems} style={{ marginBottom: 0 }} />

            {/* ── Filters ── */}
            <div className="filters-header">
                <div className="total-count">
                    Total {activeTab === "open" ? "Pending" : "Completed"}: {totalCount || data.length}
                </div>
                <Form
                    form={form}
                    layout="vertical"
                    onValuesChange={applyFormFilters}
                >
                    <div style={{ display: "flex", gap: 12, alignItems: "flex-end", flexWrap: "wrap" }}>
                        {/* FIX 4: Search input for matter name/id/client/attorney */}
                        <div style={{ width: 176 }}>
                            <DropdownCheckBox
                                name="matterName"
                                label="Matter Name"
                                options={matterNameOptions.map((m) => ({ label: m, value: m }))}
                                form={form}
                                handleFormChange={applyFormFilters}
                            />
                        </div>

                        <div style={{ width: 176 }}>
                            <DropdownCheckBox
                                name="status"
                                label="Status"
                                options={statusOptions?.map((s) => ({ label: s, value: s }))}
                                form={form}
                                handleFormChange={applyFormFilters}
                            />
                        </div>
                        <div style={{ width: 176 }}>
                            <DropdownCheckBox
                                name="client"
                                label="Client"
                                options={clientOptions.map((c) => ({ label: c, value: c }))}
                                form={form}
                                handleFormChange={applyFormFilters}
                            />
                        </div>
                        <div style={{ width: 176 }}>
                            <DropdownCheckBox
                                name="lead"
                                label="Lead"
                                options={leadOptions.map((l) => ({ label: getUserName(l), value: l }))}
                                form={form}
                                handleFormChange={applyFormFilters}
                            />
                        </div>
                        <div style={{ marginBottom: 12 }}>
                            <FilterBtn onClick={openFilterModal} title="Advanced Filters">
                                <FilterIcon style={{ cursor: "pointer", backgroundColor: "#C2FAE5", fontSize: 20 }} />
                                {advFilterCount > 0 && <FilterBadge>{advFilterCount}</FilterBadge>}
                            </FilterBtn>
                        </div>
                    </div>
                </Form>
            </div>

            {/* ── Table ── */}
            <StyledTable
                columns={columns}
                dataSource={data}
                loading={loading}
                size="small"
                pagination={{
                    current: currentPage,
                    pageSize: PAGE_LIMIT,
                    total: totalCount,
                    onChange: handlePageChange,
                    showSizeChanger: false,
                }}
                onRow={(record) => ({
                    onClick: () => {
                        if (record.matterStatus === "Draft") return;

                        history.push({
                            pathname: `/matter-details/${record.key}`,
                            state: {
                                matterData: record.originalData,
                                matterId: record.matterId,
                            },
                        });
                    },
                    style: {
                        cursor: record.matterStatus === "Draft" ? "default" : "pointer",
                    },
                })}
            />

            {/* ── Clone Modal ── */}
            <StyledModal style={{ borderRadius: 10 }}
                open={cloneModal}
                onCancel={handleCloneCancel}
                title="Cloning Matter"
                footer={null}
                width={500}
                closable
                destroyOnClose
                centered
            >
                <CloneInput
                    value={cloneName}
                    status={cloneNameError ? "error" : ""}
                    onChange={(e) => {
                        const val = e.target.value;
                        setCloneName(val);
                        if (!val.trim()) {
                            setCloneNameError("Please enter a name.");
                            return;
                        }
                        const normalized = val.trim().toLowerCase();
                        const isDuplicate = data.some(
                            (m) => (m.matter || "").trim().toLowerCase() === normalized
                        );
                        setCloneNameError(isDuplicate ? "This matter name already exists." : "");
                    }}
                    placeholder="Enter clone name"
                />
                {cloneNameError && (
                    <div style={{ color: "#ff4d4f", fontSize: 12, marginTop: 4 }}>
                        {cloneNameError}
                    </div>
                )}
                <ModalFooterRow>
                    <CancelBtn style={{ width: 150, borderRadius: 10 }} onClick={handleCloneCancel}>Cancel</CancelBtn>
                    <CloneBtn style={{ width: 150, borderRadius: 10 }} onClick={handleCloneConfirm}>Clone</CloneBtn>
                </ModalFooterRow>
            </StyledModal>

            {/* ── Delete Modal ── */}
            <StyledModal
                open={deleteModal}
                onCancel={handleDeleteCancel}
                footer={null}
                width={500}
                closable={false}
                centered
                destroyOnClose
            >
                <div style={{ textAlign: "left", padding: "24px 16px 8px" }}>
                    <p style={{ fontSize: 15, fontWeight: 500, color: "#111827", marginBottom: 32 }}>
                        Are you sure you want to delete this Matter?
                    </p>
                    <div style={{ display: "flex", justifyContent: "flex-end", gap: 16 }}>
                        <CancelBtn onClick={handleDeleteCancel} style={{ width: 150, borderRadius: 10 }}>No</CancelBtn>
                        <CloneBtn onClick={handleDeleteConfirm} style={{ width: 150 }}>Yes</CloneBtn>
                    </div>
                </div>
            </StyledModal>

            {/* ── Advanced Filter Modal ── */}
            <Modal
                open={filterModal}
                onCancel={closeFilterModal}
                title={`Filter${advFilterCount > 0 ? ` (${advFilterCount})` : ""}`}
                footer={null}
                width={1220}
                closable
                destroyOnClose
                centered
            >
                <FilterModalWrap>
                    {/* Row 1 */}
                    <FilterRow>
                        <FilterField>
                            <FilterLabel>Referrer</FilterLabel>
                            <FullSelect
                                placeholder="Select Referrer"
                                mode="multiple"
                                value={tempAdv.referrer}
                                onChange={(val) => handleAdvChange("referrer", val)}
                                allowClear
                                maxTagCount="responsive"
                            >
                                {referrerOptions.map((r) => <Option key={r} value={r}>{getUserName(r)}</Option>)}
                            </FullSelect>
                        </FilterField>

                        <FilterField>
                            <FilterLabel>Practice Area</FilterLabel>
                            <FullSelect
                                placeholder="Select Practice Area"
                                mode="multiple"
                                value={tempAdv.practiceArea}
                                allowClear
                                maxTagCount="responsive"
                                onChange={(val) => handleAdvChange("practiceArea", val)}
                            >
                                {PRACTICE_AREAS.map((group) => (
                                    <Select.OptGroup key={group.label} label={group.label}>
                                        {group.options.map((item) => (
                                            <Select.Option key={item} value={item}>{item}</Select.Option>
                                        ))}
                                    </Select.OptGroup>
                                ))}
                            </FullSelect>
                        </FilterField>

                        <FilterField style={{ flex: 2 }}>
                            <FilterLabel>Plan Date Range</FilterLabel>
                            <FullRangePicker
                                value={[tempAdv.planDateFrom, tempAdv.planDateTo]}
                                onChange={(dates) => {
                                    handleAdvChange("planDateFrom", dates?.[0] || null);
                                    handleAdvChange("planDateTo", dates?.[1] || null);
                                }}
                                format="DD MMM YYYY"
                                placeholder={["Start date", "End date"]}
                            />
                        </FilterField>
                    </FilterRow>

                    {/* Row 2 */}
                    <FilterRow>
                        <FilterField>
                            <FilterLabel>Created by</FilterLabel>
                            <FullSelect
                                placeholder="Select Creator"
                                mode="multiple"
                                value={tempAdv.createdBy}
                                onChange={(val) => handleAdvChange("createdBy", val)}
                                allowClear
                                maxTagCount="responsive"
                            >
                                {createdByOpts.map((c) => <Option key={c} value={c}>{getUserName(c)}</Option>)}
                            </FullSelect>
                        </FilterField>

                        <FilterField style={{ flex: 2 }}>
                            <FilterLabel>Created Date Range</FilterLabel>
                            <FullRangePicker
                                value={[tempAdv.createdDateFrom, tempAdv.createdDateTo]}
                                onChange={(dates) => {
                                    handleAdvChange("createdDateFrom", dates?.[0] || null);
                                    handleAdvChange("createdDateTo", dates?.[1] || null);
                                }}
                                format="DD MMM YYYY"
                                placeholder={["Start date", "End date"]}
                            />
                        </FilterField>

                        <FilterField>
                            <FilterLabel>Client Reference Number</FilterLabel>
                            <RadioGroup
                                value={tempAdv.clientRefNumber}
                                onChange={(e) => handleAdvChange("clientRefNumber", e.target.value)}
                            >
                                <Radio value="yes">Yes</Radio>
                                <Radio value="no">No</Radio>
                            </RadioGroup>
                        </FilterField>
                    </FilterRow>

                    {/* Row 3 */}
                    <FilterRow style={{ marginBottom: 8 }}>
                        <FilterField>
                            <FilterLabel>Legal Filing Deadline</FilterLabel>
                            <RadioGroup
                                value={tempAdv.legalFilingDeadline}
                                onChange={(e) => handleAdvChange("legalFilingDeadline", e.target.value)}
                            >
                                <Radio value="yes">Yes</Radio>
                                <Radio value="no">No</Radio>
                            </RadioGroup>
                        </FilterField>

                        <FilterField>
                            <FilterLabel>Legal Filing Deadline met</FilterLabel>
                            <RadioGroup
                                value={tempAdv.legalFilingDeadlineMet}
                                onChange={(e) => handleAdvChange("legalFilingDeadlineMet", e.target.value)}
                            >
                                <Radio value="yes">Yes</Radio>
                                <Radio value="no">No</Radio>
                            </RadioGroup>
                        </FilterField>

                        <FilterField style={{ flex: 2, visibility: "hidden" }} />
                    </FilterRow>

                    {/* Footer */}
                    <FilterModalFooter>
                        <ClearAllBtn onClick={handleClearAll}>Clear All</ClearAllBtn>
                        <ApplyBtn onClick={handleApplyFilter}>Apply Filter</ApplyBtn>
                    </FilterModalFooter>
                </FilterModalWrap>
            </Modal>
        </MatterWrap>
    );
};

export default Matter;